<div
  class="ml-2 flex flex-row space-x-5"
  [ngClass]="{
    'h-16':
      [fractionTypeEnum.TsIsBetween, fractionTypeEnum.TsIsNotBetween].indexOf(
        fraction.type
      ) < 0,
    'h-32':
      [fractionTypeEnum.TsIsBetween, fractionTypeEnum.TsIsNotBetween].indexOf(
        fraction.type
      ) > -1
  }"
>
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-container *ngTemplateOutlet="tSelect"></ng-container>

    <ng-template #tSelect>
      <ng-select
        #fractionTsTypeSelect
        [fixNgSelectBottom]="fractionTsTypeSelect"
        data-cy="fractionTsTypeSelect"
        class="fraction-type-select"
        [class.w-[180px]]="isMetrics === true"
        [class.w-[280px]]="isMetrics === false"
        [class.mt-[32px]]="
          [
            fractionTypeEnum.TsIsBetween,
            fractionTypeEnum.TsIsNotBetween
          ].indexOf(fraction.type) > -1
        "
        [items]="fractionTsTypesList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.type"
        (change)="typeChange($event)"
        (keyup.esc)="
          $event.stopImmediatePropagation(); fractionTsTypeSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); fractionTsTypeSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-yellow-700': item.operator === fractionOperatorEnum.And,
              'text-s400':
                item.operator !== fractionOperatorEnum.And &&
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-yellow-700': item.operator === fractionOperatorEnum.And,
              'text-s400':
                item.operator !== fractionOperatorEnum.And &&
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1" *ngIf="isMetrics === false"
              >{{ item.operator | uppercase }} -</div
            >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>
      </ng-select>
    </ng-template>
  </div>

  <div
    *ngIf="
      fraction.type === fractionTypeEnum.TsIsOnYear ||
      fraction.type === fractionTypeEnum.TsIsOnQuarter ||
      fraction.type === fractionTypeEnum.TsIsOnMonth ||
      fraction.type === fractionTypeEnum.TsIsOnWeek ||
      fraction.type === fractionTypeEnum.TsIsOnDay ||
      fraction.type === fractionTypeEnum.TsIsOnHour ||
      fraction.type === fractionTypeEnum.TsIsOnMinute ||
      fraction.type === fractionTypeEnum.TsIsOnTimestamp ||
      fraction.type === fractionTypeEnum.TsIsBefore ||
      fraction.type === fractionTypeEnum.TsIsThrough ||
      fraction.type === fractionTypeEnum.TsIsAfter ||
      fraction.type === fractionTypeEnum.TsIsStarting ||
      fraction.type === fractionTypeEnum.TsIsBeginFor ||
      fraction.type === fractionTypeEnum.TsIsNotOnYear ||
      fraction.type === fractionTypeEnum.TsIsNotOnQuarter ||
      fraction.type === fractionTypeEnum.TsIsNotOnMonth ||
      fraction.type === fractionTypeEnum.TsIsNotOnWeek ||
      fraction.type === fractionTypeEnum.TsIsNotOnDay ||
      fraction.type === fractionTypeEnum.TsIsNotOnHour ||
      fraction.type === fractionTypeEnum.TsIsNotOnMinute ||
      fraction.type === fractionTypeEnum.TsIsNotOnTimestamp ||
      fraction.type === fractionTypeEnum.TsIsNotBeginFor
    "
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #fractionTsMomentTypeSelect
        [fixNgSelectBottom]="fractionTsMomentTypeSelect"
        data-cy="fractionTsMomentTypeSelect"
        class="fraction-ts-moment-select w-[140px]"
        [items]="fractionTsMomentTypesList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsMomentType"
        (change)="momentChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); fractionTsMomentTypeSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); fractionTsMomentTypeSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate">{{ item.label }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div
    *ngIf="
      [
        fractionTypeEnum.TsIsBefore,
        fractionTypeEnum.TsIsThrough,
        fractionTypeEnum.TsIsAfter,
        fractionTypeEnum.TsIsStarting,
        fractionTypeEnum.TsIsBeginFor,
        fractionTypeEnum.TsIsOnTimestamp,
        fractionTypeEnum.TsIsNotBeginFor,
        fractionTypeEnum.TsIsNotOnTimestamp
      ].indexOf(fraction.type) > -1 &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Timestamp
    "
    class="flex flex-row space-x-5"
  >
    <div class="flex h-9 items-center">UTC</div>

    <form [formGroup]="tsTimestampValueForm">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionTsTimestampValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-[255px] rounded"
            [ngClass]="{
              'border-r600':
                tsTimestampValueForm.controls['tsTimestampValue'].invalid &&
                tsTimestampValueForm.controls['tsTimestampValue'].touched
            }"
            formControlName="tsTimestampValue"
            (blur)="timestampValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="tsTimestampValueForm.controls['tsTimestampValue']"
      ></m-validation>
    </form>
  </div>

  <div
    *ngIf="
      ([
        fractionTypeEnum.TsIsBefore,
        fractionTypeEnum.TsIsThrough,
        fractionTypeEnum.TsIsAfter,
        fractionTypeEnum.TsIsStarting,
        fractionTypeEnum.TsIsBeginFor,
        fractionTypeEnum.TsIsNotBeginFor
      ].indexOf(fraction.type) > -1 &&
        (fraction.tsMomentType === fractionTsMomentTypeEnum.Literal ||
          [
            fractionTsMomentTypeEnum.This,
            fractionTsMomentTypeEnum.Last,
            fractionTsMomentTypeEnum.Next
          ].indexOf(fraction.tsMomentType) > -1)) ||
      ([fractionTypeEnum.TsIsOnDay, fractionTypeEnum.TsIsNotOnDay].indexOf(
        fraction.type
      ) > -1 &&
        [fractionTsMomentTypeEnum.Last, fractionTsMomentTypeEnum.Next].indexOf(
          fraction.tsMomentType
        ) > -1)
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #tsMomentOnUnitSelect
      [fixNgSelectBottom]="tsMomentOnUnitSelect"
      data-cy="tsMomentOnUnitSelect"
      class="fraction-mix-unit-select"
      [class.w-[110px]]="
        fraction.tsMomentType === fractionTsMomentTypeEnum.Literal ||
        fraction.tsMomentType === fractionTsMomentTypeEnum.This
      "
      [class.w-[150px]]="
        fraction.tsMomentType !== fractionTsMomentTypeEnum.Literal &&
        fraction.tsMomentType !== fractionTsMomentTypeEnum.This
      "
      [items]="
        [fractionTypeEnum.TsIsOnDay, fractionTypeEnum.TsIsNotOnDay].indexOf(
          fraction.type
        ) > -1 &&
        [fractionTsMomentTypeEnum.Last, fractionTsMomentTypeEnum.Next].indexOf(
          fraction.tsMomentType
        ) > -1
          ? fractionTsOnDayUnitsList
          : fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
            ? fractionTsLiteralUnitsList
            : fraction.tsMomentType === fractionTsMomentTypeEnum.This
              ? fractionTsMixUnitsTempList
              : fractionTsOnUnitsList
      "
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.tsMomentUnit"
      (change)="onUnitChange()"
      (keyup.esc)="
        $event.stopImmediatePropagation(); tsMomentOnUnitSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation(); tsMomentOnUnitSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-s400':
              item.timeframeLevel !== 0 &&
              item.timeframeLevel < fieldTimeframeLevel
          }"
        >
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-s400':
              item.timeframeLevel !== 0 &&
              item.timeframeLevel < fieldTimeframeLevel
          }"
        >
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <div
    *ngIf="
      [
        fractionTypeEnum.TsIsOnYear,
        fractionTypeEnum.TsIsOnQuarter,
        fractionTypeEnum.TsIsOnMonth,
        fractionTypeEnum.TsIsOnWeek,
        fractionTypeEnum.TsIsOnDay,
        fractionTypeEnum.TsIsOnHour,
        fractionTypeEnum.TsIsOnMinute,
        fractionTypeEnum.TsIsBefore,
        fractionTypeEnum.TsIsThrough,
        fractionTypeEnum.TsIsAfter,
        fractionTypeEnum.TsIsStarting,
        fractionTypeEnum.TsIsBeginFor,
        fractionTypeEnum.TsIsNotOnYear,
        fractionTypeEnum.TsIsNotOnQuarter,
        fractionTypeEnum.TsIsNotOnMonth,
        fractionTypeEnum.TsIsNotOnWeek,
        fractionTypeEnum.TsIsNotOnDay,
        fractionTypeEnum.TsIsNotOnHour,
        fractionTypeEnum.TsIsNotOnMinute,
        fractionTypeEnum.TsIsNotBeginFor
      ].indexOf(fraction.type) > -1 &&
      [fractionTsMomentTypeEnum.Ago, fractionTsMomentTypeEnum.FromNow].indexOf(
        fraction.tsMomentType
      ) > -1
    "
    class="flex flex-row space-x-5"
  >
    <form [formGroup]="tsMomentAgoFromNowQuantityForm">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionTsMomentAgoFromNowQuantityInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-16 rounded"
            [ngClass]="{
              'border-r600':
                tsMomentAgoFromNowQuantityForm.controls[
                  'tsMomentAgoFromNowQuantity'
                ].invalid &&
                tsMomentAgoFromNowQuantityForm.controls[
                  'tsMomentAgoFromNowQuantity'
                ].touched
            }"
            formControlName="tsMomentAgoFromNowQuantity"
            (blur)="agoFromNowQuantityBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="
          tsMomentAgoFromNowQuantityForm.controls['tsMomentAgoFromNowQuantity']
        "
      ></m-validation>
    </form>
  </div>

  <div
    *ngIf="
      [
        fractionTypeEnum.TsIsBefore,
        fractionTypeEnum.TsIsThrough,
        fractionTypeEnum.TsIsAfter,
        fractionTypeEnum.TsIsStarting,
        fractionTypeEnum.TsIsBeginFor,
        fractionTypeEnum.TsIsNotBeginFor
      ].indexOf(fraction.type) > -1 &&
      [fractionTsMomentTypeEnum.Ago, fractionTsMomentTypeEnum.FromNow].indexOf(
        fraction.tsMomentType
      ) > -1
    "
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #tsMomentAgoFromNowUnitSelect
        [fixNgSelectBottom]="tsMomentAgoFromNowUnitSelect"
        data-cy="tsMomentAgoFromNowUnitSelect"
        class="popup-55 w-32"
        [items]="fractionTsAgoFromNowUnitsList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsMomentUnit"
        (change)="agoFromNowUnitChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); tsMomentAgoFromNowUnitSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); tsMomentAgoFromNowUnitSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label + 's' }}</div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label + 's' }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div
    *ngIf="
      [
        fractionTypeEnum.TsIsOnYear,
        fractionTypeEnum.TsIsOnQuarter,
        fractionTypeEnum.TsIsOnMonth,
        fractionTypeEnum.TsIsOnWeek,
        fractionTypeEnum.TsIsOnDay,
        fractionTypeEnum.TsIsOnHour,
        fractionTypeEnum.TsIsOnMinute,
        fractionTypeEnum.TsIsNotOnYear,
        fractionTypeEnum.TsIsNotOnQuarter,
        fractionTypeEnum.TsIsNotOnMonth,
        fractionTypeEnum.TsIsNotOnWeek,
        fractionTypeEnum.TsIsNotOnDay,
        fractionTypeEnum.TsIsNotOnHour,
        fractionTypeEnum.TsIsNotOnMinute
      ].indexOf(fraction.type) > -1 &&
      [fractionTsMomentTypeEnum.Ago, fractionTsMomentTypeEnum.FromNow].indexOf(
        fraction.tsMomentType
      ) > -1
    "
  >
    <div class="flex h-9 items-center">{{ fraction.tsMomentUnit + 's' }}</div>
  </div>

  <!-- on year -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnYear, fractionTypeEnum.TsIsNotOnYear].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <vaadin-date-picker
      #datePickerOnYear
      class="py-0"
      required
      [value]="dateStr"
      [i18n]="onYearDateI18n"
      (value-changed)="yearDateValueChanged($event)"
      [disabled]="isDisabled === true"
    ></vaadin-date-picker>
  </div>

  <!-- on quarter -->
  <div
    *ngIf="
      [
        fractionTypeEnum.TsIsOnQuarter,
        fractionTypeEnum.TsIsNotOnQuarter
      ].indexOf(fraction.type) > -1 &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <vaadin-date-picker
      #datePickerOnQuarter
      class="py-0"
      required
      [value]="dateStr"
      [i18n]="onQuarterDateI18n"
      (value-changed)="quarterDateValueChanged($event)"
      [disabled]="isDisabled === true"
    ></vaadin-date-picker>
  </div>

  <!-- on month -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnMonth, fractionTypeEnum.TsIsNotOnMonth].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <vaadin-date-picker
      #datePickerOnMonth
      class="py-0"
      required
      [value]="dateStr"
      [i18n]="onMonthDateI18n"
      (value-changed)="monthDateValueChanged($event)"
      [disabled]="isDisabled === true"
    ></vaadin-date-picker>
  </div>

  <!-- on week -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnWeek, fractionTypeEnum.TsIsNotOnWeek].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <vaadin-date-picker
      #datePickerOnWeek
      class="week-width py-0"
      required
      [value]="dateStr"
      [i18n]="onWeekDateI18n"
      (value-changed)="weekDateValueChanged($event)"
      [disabled]="isDisabled === true"
    ></vaadin-date-picker>
  </div>

  <!-- on day -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnDay, fractionTypeEnum.TsIsNotOnDay].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <vaadin-date-picker
      #datePickerOnDay
      class="py-0"
      required
      [value]="dateStr"
      [i18n]="onDayDateI18n"
      (value-changed)="dayDateValueChanged($event)"
      [disabled]="isDisabled === true"
    ></vaadin-date-picker>
  </div>

  <!-- on hour -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnHour, fractionTypeEnum.TsIsNotOnHour].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerOnHour
        class="py-0"
        required
        [value]="dateStr"
        [i18n]="onHourDateI18n"
        (value-changed)="hourDateValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerOnHour
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="hourTimeValueChanged($event)"
        (opened-changed)="hourTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- on minute -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsOnMinute, fractionTypeEnum.TsIsNotOnMinute].indexOf(
        fraction.type
      ) > -1 && fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerOnMinute
        class="py-0"
        required
        [value]="dateStr"
        [i18n]="onMinuteDateI18n"
        (value-changed)="minuteDateValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerOnMinute
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="minuteTimeValueChanged($event)"
        (opened-changed)="minuteTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- between -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsBetween, fractionTypeEnum.TsIsNotBetween].indexOf(
        fraction.type
      ) > -1
    "
    class="flex flex-col"
  >
    <div class="flex h-16 flex-row space-x-5">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <ng-select
          #fractionTsFromMomentTypeSelect
          [fixNgSelectBottom]="fractionTsFromMomentTypeSelect"
          data-cy="fractionTsFromMomentTypeSelect"
          class="fraction-ts-moment-select w-[140px]"
          [items]="fractionTsMomentTypesList"
          [clearable]="false"
          [searchable]="false"
          [disabled]="isDisabled === true"
          [(ngModel)]="fraction.tsFromMomentType"
          (change)="betweenFromMomentChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            fractionTsFromMomentTypeSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            fractionTsFromMomentTypeSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 truncate">{{ item.label }}</div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate">{{ item.label }}</div>
          </ng-template>
        </ng-select>
      </div>

      <div
        *ngIf="fraction.tsFromMomentType === fractionTsMomentTypeEnum.Timestamp"
        class="flex flex-row space-x-5"
      >
        <div class="flex h-9 items-center">UTC</div>

        <form [formGroup]="tsFromTimestampValueForm">
          <div
            tp="Turn off formula to activate control"
            [tpIsEnabled]="isDisabled === true"
          >
            <fieldset [disabled]="isDisabled === true">
              <input
                autocomplete="off"
                spellcheck="false"
                data-cy="fractionTsFromTimestampValueInput"
                class="form-input border-s3 focus:border-m600 h-[36px] w-[255px] rounded"
                [ngClass]="{
                  'border-r600':
                    tsFromTimestampValueForm.controls['tsFromTimestampValue']
                      .invalid &&
                    tsFromTimestampValueForm.controls['tsFromTimestampValue']
                      .touched
                }"
                formControlName="tsFromTimestampValue"
                (blur)="betweenFromTimestampValueBlur()"
              />
            </fieldset>
          </div>

          <m-validation
            [control]="
              tsFromTimestampValueForm.controls['tsFromTimestampValue']
            "
          ></m-validation>
        </form>
      </div>

      <div
        *ngIf="
          [
            fractionTsMomentTypeEnum.Ago,
            fractionTsMomentTypeEnum.FromNow
          ].indexOf(fraction.tsFromMomentType) > -1
        "
        class="flex flex-row space-x-5"
      >
        <form [formGroup]="tsFromMomentAgoFromNowQuantityForm">
          <div
            tp="Turn off formula to activate control"
            [tpIsEnabled]="isDisabled === true"
          >
            <fieldset [disabled]="isDisabled === true">
              <input
                autocomplete="off"
                spellcheck="false"
                data-cy="fractionTsFromMomentAgoFromNowQuantityInput"
                class="form-input border-s3 focus:border-m600 h-[36px] w-16 rounded"
                [ngClass]="{
                  'border-r600':
                    tsFromMomentAgoFromNowQuantityForm.controls[
                      'tsFromMomentAgoFromNowQuantity'
                    ].invalid &&
                    tsFromMomentAgoFromNowQuantityForm.controls[
                      'tsFromMomentAgoFromNowQuantity'
                    ].touched
                }"
                formControlName="tsFromMomentAgoFromNowQuantity"
                (blur)="betweenFromMomentAgoFromNowQuantityBlur()"
              />
            </fieldset>
          </div>

          <m-validation
            [control]="
              tsFromMomentAgoFromNowQuantityForm.controls[
                'tsFromMomentAgoFromNowQuantity'
              ]
            "
          ></m-validation>
        </form>

        <div
          tp="Turn off formula to activate control"
          [tpIsEnabled]="isDisabled === true"
        >
          <ng-select
            #tsFromMomentAgoFromNowUnitSelect
            [fixNgSelectBottom]="tsFromMomentAgoFromNowUnitSelect"
            data-cy="tsFromMomentAgoFromNowUnitSelect"
            class="popup-55 w-32"
            [items]="fractionTsAgoFromNowUnitsList"
            [clearable]="false"
            [searchable]="false"
            [disabled]="isDisabled === true"
            [(ngModel)]="fraction.tsFromMomentUnit"
            (change)="betweenFromMomentAgoFromNowUnitChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation();
              tsFromMomentAgoFromNowUnitSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation();
              tsFromMomentAgoFromNowUnitSelect.blur()
            "
            appendTo="body"
            bindLabel="label"
            bindValue="value"
          >
            <ng-template ng-label-tmp let-item="item">
              <div
                class="flex flex-row"
                [ngClass]="{
                  'text-s400':
                    item.timeframeLevel !== 0 &&
                    item.timeframeLevel < fieldTimeframeLevel
                }"
              >
                <div class="ml-1 truncate">{{ item.label + 's' }}</div>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div
                class="flex flex-row"
                [ngClass]="{
                  'text-s400':
                    item.timeframeLevel !== 0 &&
                    item.timeframeLevel < fieldTimeframeLevel
                }"
              >
                <div class="ml-1 truncate">{{ item.label + 's' }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div
        *ngIf="
          fraction.tsFromMomentType === fractionTsMomentTypeEnum.Literal ||
          [
            fractionTsMomentTypeEnum.This,
            fractionTsMomentTypeEnum.Last,
            fractionTsMomentTypeEnum.Next
          ].indexOf(fraction.tsFromMomentType) > -1
        "
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <ng-select
          #tsFromMomentOnUnitSelect
          [fixNgSelectBottom]="tsFromMomentOnUnitSelect"
          data-cy="tsFromMomentOnUnitSelect"
          class="fraction-mix-unit-select"
          [class.w-[110px]]="
            fraction.tsFromMomentType === fractionTsMomentTypeEnum.Literal
          "
          [class.w-[150px]]="
            fraction.tsFromMomentType !== fractionTsMomentTypeEnum.Literal
          "
          [items]="
            fraction.tsFromMomentType === fractionTsMomentTypeEnum.Literal
              ? fractionTsLiteralUnitsList
              : fraction.tsFromMomentType === fractionTsMomentTypeEnum.This
                ? fractionTsMixUnitsTempList
                : fractionTsOnUnitsList
          "
          [clearable]="false"
          [searchable]="false"
          [disabled]="isDisabled === true"
          [(ngModel)]="fraction.tsFromMomentUnit"
          (change)="betweenFromUnitChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); tsFromMomentOnUnitSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); tsFromMomentOnUnitSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="flex flex-row"
              [ngClass]="{
                'text-s400':
                  item.timeframeLevel !== 0 &&
                  item.timeframeLevel < fieldTimeframeLevel
              }"
            >
              <div class="ml-1 truncate">{{ item.label }}</div>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div
              class="flex flex-row"
              [ngClass]="{
                'text-s400':
                  item.timeframeLevel !== 0 &&
                  item.timeframeLevel < fieldTimeframeLevel
              }"
            >
              <div class="ml-1 truncate">{{ item.label }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div
        *ngIf="fraction.tsFromMomentType === fractionTsMomentTypeEnum.Literal"
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <vaadin-date-picker
          #datePickerBetweenFrom
          class="py-0"
          [ngClass]="{
            'week-width': fraction.tsFromMomentUnit === 'week'
          }"
          required
          [value]="dateStr"
          [i18n]="betweenFromDateI18n"
          (value-changed)="betweenFromDateValueChanged($event)"
          [disabled]="isDisabled === true"
        ></vaadin-date-picker>
      </div>

      <div
        *ngIf="
          fraction.tsFromMomentType === fractionTsMomentTypeEnum.Literal &&
          ['hour', 'minute'].indexOf(fraction.tsFromMomentUnit) > -1
        "
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <vaadin-time-picker
          #timePickerBetweenFrom
          class="py-0"
          required
          [value]="timeStr"
          (value-changed)="betweenFromTimeValueChanged($event)"
          (opened-changed)="betweenFromTimeOpenedChanged($event)"
          [disabled]="isDisabled === true"
        ></vaadin-time-picker>
      </div>
    </div>

    <div class="flex h-16 flex-row space-x-5">
      <!-- <div class="flex h-[36px] items-center justify-center">to</div> -->

      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <ng-select
          #fractionTsToMomentTypeSelect
          [fixNgSelectBottom]="fractionTsToMomentTypeSelect"
          data-cy="fractionTsToMomentTypeSelect"
          class="fraction-ts-moment-select w-[140px]"
          [items]="fractionTsMomentTypesList"
          [clearable]="false"
          [searchable]="false"
          [disabled]="isDisabled === true"
          [(ngModel)]="fraction.tsToMomentType"
          (change)="betweenToMomentChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            fractionTsToMomentTypeSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            fractionTsToMomentTypeSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="ml-1 truncate">{{ item.label }}</div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate">{{ item.label }}</div>
          </ng-template>
        </ng-select>
      </div>

      <div
        *ngIf="fraction.tsToMomentType === fractionTsMomentTypeEnum.Timestamp"
        class="flex flex-row space-x-5"
      >
        <div class="flex h-9 items-center">UTC</div>

        <form [formGroup]="tsToTimestampValueForm">
          <div
            tp="Turn off formula to activate control"
            [tpIsEnabled]="isDisabled === true"
          >
            <fieldset [disabled]="isDisabled === true">
              <input
                autocomplete="off"
                spellcheck="false"
                data-cy="fractionTsToTimestampValueInput"
                class="form-input border-s3 focus:border-m600 h-[36px] w-[255px] rounded"
                [ngClass]="{
                  'border-r600':
                    tsToTimestampValueForm.controls['tsToTimestampValue']
                      .invalid &&
                    tsToTimestampValueForm.controls['tsToTimestampValue']
                      .touched
                }"
                formControlName="tsToTimestampValue"
                (blur)="betweenToTimestampValueBlur()"
              />
            </fieldset>
          </div>

          <m-validation
            [control]="tsToTimestampValueForm.controls['tsToTimestampValue']"
          ></m-validation>
        </form>
      </div>

      <div
        *ngIf="
          [
            fractionTsMomentTypeEnum.Ago,
            fractionTsMomentTypeEnum.FromNow
          ].indexOf(fraction.tsToMomentType) > -1
        "
        class="flex flex-row space-x-5"
      >
        <form [formGroup]="tsToMomentAgoFromNowQuantityForm">
          <div
            tp="Turn off formula to activate control"
            [tpIsEnabled]="isDisabled === true"
          >
            <fieldset [disabled]="isDisabled === true">
              <input
                autocomplete="off"
                spellcheck="false"
                data-cy="fractionTsToMomentAgoFromNowQuantityInput"
                class="form-input border-s3 focus:border-m600 h-[36px] w-16 rounded"
                [ngClass]="{
                  'border-r600':
                    tsToMomentAgoFromNowQuantityForm.controls[
                      'tsToMomentAgoFromNowQuantity'
                    ].invalid &&
                    tsToMomentAgoFromNowQuantityForm.controls[
                      'tsToMomentAgoFromNowQuantity'
                    ].touched
                }"
                formControlName="tsToMomentAgoFromNowQuantity"
                (blur)="betweenToMomentAgoFromNowQuantityBlur()"
              />
            </fieldset>
          </div>

          <m-validation
            [control]="
              tsToMomentAgoFromNowQuantityForm.controls[
                'tsToMomentAgoFromNowQuantity'
              ]
            "
          ></m-validation>
        </form>

        <div
          tp="Turn off formula to activate control"
          [tpIsEnabled]="isDisabled === true"
        >
          <ng-select
            #tsToMomentAgoFromNowUnitSelect
            [fixNgSelectBottom]="tsToMomentAgoFromNowUnitSelect"
            data-cy="tsToMomentAgoFromNowUnitSelect"
            class="popup-55 w-32"
            [items]="fractionTsAgoFromNowUnitsList"
            [clearable]="false"
            [searchable]="false"
            [disabled]="isDisabled === true"
            [(ngModel)]="fraction.tsToMomentUnit"
            (change)="betweenToMomentAgoFromNowUnitChange()"
            (keyup.esc)="
              $event.stopImmediatePropagation();
              tsToMomentAgoFromNowUnitSelect.blur()
            "
            (keyup.enter)="
              $event.stopImmediatePropagation();
              tsToMomentAgoFromNowUnitSelect.blur()
            "
            appendTo="body"
            bindLabel="label"
            bindValue="value"
          >
            <ng-template ng-label-tmp let-item="item">
              <div
                class="flex flex-row"
                [ngClass]="{
                  'text-s400':
                    item.timeframeLevel !== 0 &&
                    item.timeframeLevel < fieldTimeframeLevel
                }"
              >
                <div class="ml-1 truncate">{{ item.label + 's' }}</div>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item">
              <div
                class="flex flex-row"
                [ngClass]="{
                  'text-s400':
                    item.timeframeLevel !== 0 &&
                    item.timeframeLevel < fieldTimeframeLevel
                }"
              >
                <div class="ml-1 truncate">{{ item.label + 's' }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div
        *ngIf="
          fraction.tsToMomentType === fractionTsMomentTypeEnum.Literal ||
          [
            fractionTsMomentTypeEnum.This,
            fractionTsMomentTypeEnum.Last,
            fractionTsMomentTypeEnum.Next
          ].indexOf(fraction.tsToMomentType) > -1
        "
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <ng-select
          #tsToMomentOnUnitSelect
          [fixNgSelectBottom]="tsToMomentOnUnitSelect"
          data-cy="tsToMomentOnUnitSelect"
          class="fraction-mix-unit-select"
          [class.w-[110px]]="
            fraction.tsToMomentType === fractionTsMomentTypeEnum.Literal
          "
          [class.w-[150px]]="
            fraction.tsToMomentType !== fractionTsMomentTypeEnum.Literal
          "
          [items]="
            fraction.tsToMomentType === fractionTsMomentTypeEnum.Literal
              ? fractionTsLiteralUnitsList
              : fraction.tsToMomentType === fractionTsMomentTypeEnum.This
                ? fractionTsMixUnitsTempList
                : fractionTsOnUnitsList
          "
          [clearable]="false"
          [searchable]="false"
          [disabled]="isDisabled === true"
          [(ngModel)]="fraction.tsToMomentUnit"
          (change)="betweenToUnitChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation(); tsToMomentOnUnitSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation(); tsToMomentOnUnitSelect.blur()
          "
          appendTo="body"
          bindLabel="label"
          bindValue="value"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="flex flex-row"
              [ngClass]="{
                'text-s400':
                  item.timeframeLevel !== 0 &&
                  item.timeframeLevel < fieldTimeframeLevel
              }"
            >
              <div class="ml-1 truncate">{{ item.label }}</div>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div
              class="flex flex-row"
              [ngClass]="{
                'text-s400':
                  item.timeframeLevel !== 0 &&
                  item.timeframeLevel < fieldTimeframeLevel
              }"
            >
              <div class="ml-1 truncate">{{ item.label }}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div
        *ngIf="fraction.tsToMomentType === fractionTsMomentTypeEnum.Literal"
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <vaadin-date-picker
          #datePickerBetweenTo
          class="py-0"
          [ngClass]="{
            'week-width': fraction.tsToMomentUnit === 'week'
          }"
          required
          [value]="dateToStr"
          [i18n]="betweenToDateI18n"
          (value-changed)="betweenToDateValueChanged($event)"
          [disabled]="isDisabled === true"
        ></vaadin-date-picker>
      </div>

      <div
        *ngIf="
          fraction.tsToMomentType === fractionTsMomentTypeEnum.Literal &&
          ['hour', 'minute'].indexOf(fraction.tsToMomentUnit) > -1
        "
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <vaadin-time-picker
          #timePickerBetweenTo
          class="py-0"
          required
          [value]="timeToStr"
          (value-changed)="betweenToTimeValueChanged($event)"
          (opened-changed)="betweenToTimeOpenedChanged($event)"
          [disabled]="isDisabled === true"
        ></vaadin-time-picker>
      </div>
    </div>
  </div>

  <!-- is before -->
  <div
    *ngIf="
      fraction.type === fractionTypeEnum.TsIsBefore &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerBefore
        class="py-0"
        [ngClass]="{
          'week-width': fraction.tsMomentUnit === 'week'
        }"
        required
        [value]="dateStr"
        [i18n]="beforeI18n"
        (value-changed)="beforeValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      *ngIf="['hour', 'minute'].indexOf(fraction.tsMomentUnit) > -1"
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerBefore
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="beforeTimeValueChanged($event)"
        (opened-changed)="beforeTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- is through -->
  <div
    *ngIf="
      fraction.type === fractionTypeEnum.TsIsThrough &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerThrough
        class="py-0"
        [ngClass]="{
          'week-width': fraction.tsMomentUnit === 'week'
        }"
        required
        [value]="dateStr"
        [i18n]="throughI18n"
        (value-changed)="throughDateValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      *ngIf="['hour', 'minute'].indexOf(fraction.tsMomentUnit) > -1"
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerThrough
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="throughTimeValueChanged($event)"
        (opened-changed)="throughTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- is after -->
  <div
    *ngIf="
      fraction.type === fractionTypeEnum.TsIsAfter &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerAfter
        class="py-0"
        [ngClass]="{
          'week-width': fraction.tsMomentUnit === 'week'
        }"
        required
        [value]="dateStr"
        [i18n]="afterI18n"
        (value-changed)="afterValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      *ngIf="['hour', 'minute'].indexOf(fraction.tsMomentUnit) > -1"
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerAfter
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="afterTimeValueChanged($event)"
        (opened-changed)="afterTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- is starting -->
  <div
    *ngIf="
      fraction.type === fractionTypeEnum.TsIsStarting &&
      fraction.tsMomentType === fractionTsMomentTypeEnum.Literal
    "
    class="flex flex-row space-x-5"
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerStarting
        class="py-0"
        [ngClass]="{
          'week-width': fraction.tsMomentUnit === 'week'
        }"
        required
        [value]="dateStr"
        [i18n]="startingI18n"
        (value-changed)="startingDateValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      *ngIf="['hour', 'minute'].indexOf(fraction.tsMomentUnit) > -1"
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerStarting
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="startingTimeValueChanged($event)"
        (opened-changed)="startingTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>
  </div>

  <!-- is begin for -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsBeginFor, fractionTypeEnum.TsIsNotBeginFor].indexOf(
        fraction.type
      ) > -1
    "
    class="flex flex-row space-x-5"
  >
    <div
      *ngIf="fraction.tsMomentType === fractionTsMomentTypeEnum.Literal"
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-date-picker
        #datePickerBeginFor
        class="py-0"
        [ngClass]="{
          'week-width': fraction.tsMomentUnit === 'week'
        }"
        required
        [value]="dateStr"
        [i18n]="beginForI18n"
        (value-changed)="beginForDateValueChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-date-picker>
    </div>

    <div
      *ngIf="
        fraction.tsMomentType === fractionTsMomentTypeEnum.Literal &&
        ['hour', 'minute'].indexOf(fraction.tsMomentUnit) > -1
      "
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <vaadin-time-picker
        #timePickerBeginFor
        class="py-0"
        required
        [value]="timeStr"
        (value-changed)="beginForTimeValueChanged($event)"
        (opened-changed)="beginForTimeOpenedChanged($event)"
        [disabled]="isDisabled === true"
      ></vaadin-time-picker>
    </div>

    <div class="flex h-9 items-center">for</div>

    <form [formGroup]="tsForValueForm">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionTsForValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-16 rounded"
            [ngClass]="{
              'border-r600':
                tsForValueForm.controls['tsForValue'].invalid &&
                tsForValueForm.controls['tsForValue'].touched
            }"
            formControlName="tsForValue"
            (blur)="forValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="tsForValueForm.controls['tsForValue']"
      ></m-validation>
    </form>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #tsForUnitsSelect
        [fixNgSelectBottom]="tsForUnitsSelect"
        data-cy="tsForUnitsSelect"
        class="popup-55 w-32"
        [items]="fractionTsForUnitsList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsForUnit"
        (change)="tsForUnitChange()"
        (keyup.esc)="$event.stopImmediatePropagation(); tsForUnitsSelect.blur()"
        (keyup.enter)="
          $event.stopImmediatePropagation(); tsForUnitsSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- in last -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsInLast, fractionTypeEnum.TsIsNotInLast].indexOf(
        fraction.type
      ) > -1
    "
    class="flex flex-row space-x-5"
  >
    <form [formGroup]="tsLastValueForm">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionTsLastValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-[100px] rounded"
            [ngClass]="{
              'border-r600':
                tsLastValueForm.controls['tsLastValue'].invalid &&
                tsLastValueForm.controls['tsLastValue'].touched
            }"
            formControlName="tsLastValue"
            (blur)="lastValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="tsLastValueForm.controls['tsLastValue']"
      ></m-validation>
    </form>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #tsLastUnitsSelect
        [fixNgSelectBottom]="tsLastUnitsSelect"
        data-cy="tsLastUnitsSelect"
        class="popup-55 w-32"
        [items]="fractionTsLastNextUnitsList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsLastUnit"
        (change)="lastUnitChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); tsLastUnitsSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); tsLastUnitsSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #tsLastCompleteOptionsSelect
        [fixNgSelectBottom]="tsLastCompleteOptionsSelect"
        data-cy="tsLastCompleteOptionsSelect"
        class="popup-55 w-[250px]"
        [items]="fractionTsLastCompleteOptionsList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsLastCompleteOption"
        (change)="lastCompleteOptionChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); tsLastCompleteOptionsSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); tsLastCompleteOptionsSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate">{{ item.label }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- in next -->
  <div
    *ngIf="
      [fractionTypeEnum.TsIsInNext, fractionTypeEnum.TsIsNotInNext].indexOf(
        fraction.type
      ) > -1
    "
    class="flex flex-row space-x-5"
  >
    <form [formGroup]="tsNextValueForm">
      <div
        tp="Turn off formula to activate control"
        [tpIsEnabled]="isDisabled === true"
      >
        <fieldset [disabled]="isDisabled === true">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="fractionTsNextValueInput"
            class="form-input border-s3 focus:border-m600 h-[36px] w-[100px] rounded"
            [ngClass]="{
              'border-r600':
                tsNextValueForm.controls['tsNextValue'].invalid &&
                tsNextValueForm.controls['tsNextValue'].touched
            }"
            formControlName="tsNextValue"
            (blur)="nextValueBlur()"
          />
        </fieldset>
      </div>

      <m-validation
        [control]="tsNextValueForm.controls['tsNextValue']"
      ></m-validation>
    </form>

    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <ng-select
        #tsNextUnitsSelect
        [fixNgSelectBottom]="tsNextUnitsSelect"
        data-cy="tsNextUnitsSelect"
        class="popup-55 w-32"
        [items]="fractionTsLastNextUnitsList"
        [clearable]="false"
        [searchable]="false"
        [disabled]="isDisabled === true"
        [(ngModel)]="fraction.tsNextUnit"
        (change)="nextUnitChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation(); tsNextUnitsSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation(); tsNextUnitsSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="value"
      >
        <ng-template ng-label-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div
            class="flex flex-row"
            [ngClass]="{
              'text-s400':
                item.timeframeLevel !== 0 &&
                item.timeframeLevel < fieldTimeframeLevel
            }"
          >
            <div class="ml-1 truncate">{{ item.label }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>
